/**
 * Milliseconds for sorting/display. Supports Firestore Timestamp, Date, ISO string, or missing.
 * @param {{ submittedAt?: unknown }} item
 * @returns {number}
 */
export function submittedAtToMillis(item) {
  const s = item?.submittedAt;
  if (s == null) return 0;
  if (typeof s.toDate === 'function') {
    const d = s.toDate();
    return d instanceof Date && !Number.isNaN(d.getTime()) ? d.getTime() : 0;
  }
  if (s instanceof Date) return Number.isNaN(s.getTime()) ? 0 : s.getTime();
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? 0 : d.getTime();
}
